export function useApi() {
    const { $api } = useNuxtApp()
    return {
        api: $api
    }
}

export const API = {
    get(url: string, config?: any) {
        return useNuxtApp().$api.get(url, config)
    },
    post(url: string, data?: any, config?: any) {
        return useNuxtApp().$api.post(url, data, config)
    },
    put(url: string, data?: any, config?: any) {
        return useNuxtApp().$api.put(url, data, config)
    },
    delete(url: string, config?: any) {
        return useNuxtApp().$api.delete(url, config)
    },
    patch(url: string, data?: any, config?: any) {
        return useNuxtApp().$api.patch(url, data, config)
    }
}
